import { render } from "./AngleSize.vue?vue&type=template&id=a1afeaf0"
import script from "./AngleSize.vue?vue&type=script&lang=js"
export * from "./AngleSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__